import { Link, useLocation } from 'react-router';
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@xiltrion/ui/alert';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { useFailedEmailCount } from './api';

/** Aviso arriba de cada pantalla mientras haya correos al ciudadano sin enviar (de los casos que la persona ve). */
export function EmailFailuresNotice() {
  const { pathname } = useLocation();
  const q = useFailedEmailCount();
  const n = q.data?.count ?? 0;
  if (!n || pathname.startsWith('/correos-no-enviados')) return null;
  return (
    <Alert variant="destructive" className="mb-4">
      <Icono nombre="mdi:email-alert-outline" aria-hidden />
      <AlertTitle>{n === 1 ? 'Un correo al ciudadano no se envió' : `${n} correos al ciudadano no se enviaron`}</AlertTitle>
      <AlertDescription>El ciudadano no recibió esa comunicación. Reenvíala o resuélvela por otro medio.</AlertDescription>
      <AlertAction><Button size="sm" asChild><Link to="/correos-no-enviados">Ver correos</Link></Button></AlertAction>
    </Alert>
  );
}
